import './style.scss'
export default function MainBlock() {
    return <div id="mainBlock" className="main-block">

        <div className="main-block__wrapper container">
            <div className="main-block__text-wrapper" data-aos="fade-up">
                <h1 className="main-block__title">Finance Meets Intelligence</h1>
                <span className="main-block__text">From automation and transparency to blockchain and AI — your capital enters a smarter system.</span>
                <a href="https://market.freedom7-24.com/" className="button">How it works</a>
            </div>
        </div>

    </div>
}